<template>
  <div class="categorizedProductDisplay">
    <div class="categorizedHeader">
      <div class="categorizeTitle">Éclairage professionnel</div>
      <div class="categorizeBtn">
        <span>More</span>
        <span class="categorizeIcon"><i class="el-icon-arrow-right"></i></span>
      </div>
    </div>
    <div class="categorizedProductBox">
      <div
        class="categorizedProduct"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="ProductImgBox">
          <img class="ProductImg" :src="item.img" alt="" />
        </div>
        <div class="ProductIntroduction">
          <div class="ProductTitle">{{ item.title }}</div>
          <div class="Productprice">{{ item.price }}pieces (Min Order)</div>
          <div class="Productshop">XILiHai</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          img: 'https://cbu01.alicdn.com/img/ibank/O1CN01yyAtfr2BMRYBJf54V_!!2207971498324-0-cib.jpg_300x300q90.jpg_.webp',
          title: '家居无火香薰空气清新剂香氛卧室卫生间香薰精油芳香香水摆件50ml',
          price: 200,
        },
      ],
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.categorizedProductDisplay {
  .categorizedHeader {
    display: flex;
    justify-content: space-between;
    .categorizeTitle {
      color: rgb(58, 58, 58);
      font-size: 22px;
      font-weight: 400;
    }
    .categorizeBtn {
      font-size: 18px;
      color: rgb(102, 102, 102);
      padding-right: 14px;
      display: flex;
      .categorizeIcon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .categorizedProductBox {
    margin-top: 20px;
    display: flex;
    .categorizedProduct {
      cursor: pointer;
      height: 346px;
      width: 291px;
      margin-right: 12px;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: center;
      background-color: #fff;
      .ProductImgBox {
        height: 55%;
        padding-top: 20px;
        display: flex;
        justify-content: center;

        .ProductImg {
          width: 170px;
          height: 170px;
        }
      }
      .ProductIntroduction {
        display: flex;
        // justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 20px;
        .ProductTitle {
          font-size: 16px;
          font-weight: 400;
          color: #3a3a3a;
          width: 170px;
          white-space: nowrap; /* 禁止换行 */
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
        .Productprice {
          margin-top: 20px;
          font-size: 14px;
          font-weight: 700;
          color: #cc0e11;
        }
        .Productshop {
          margin-top: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #999;
        }
      }
    }
    .categorizedProduct:hover {
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
